import {get} from 'svelte/store';
import {analytics, dyData, modal, popupData} from 'general/store';
import {ANALYTICS, COOKIE_VALUE, POPUP_TYPE, STATE} from 'general/constants';
import {sendAnalyticsPerDay} from 'general/libs/pushDataLayer';
import {getCookie} from 'general/libs/getCookie';

export const initializeTriggerPopup = (): void => {
    const data = get(popupData);
    const modalState = get(modal);

    const triggerSelector = modalState.popupSelectors.triggerPopup;
    const isTriggerTemplate = data.value?.[triggerSelector]?.template;

    dyData.set(data.value[triggerSelector]);
    analytics.set(data.analytics[triggerSelector]);

    if (!isTriggerTemplate) {
        sendAnalyticsPerDay(ANALYTICS.POPUP_SHOWED);
    }

    modal.changePopupType(POPUP_TYPE.TRIGGER);

    if (getCookie(COOKIE_VALUE.SUBSCRIBER_PHONE)) {
        modal.changeState(STATE.TYP);
    }

    modal.initialize(Boolean(data.value[triggerSelector].isOpen));

    window.addEventListener('dynamicYield:TPopupOpen', () => {
        modal.handleTriggerPopup();
    });
};
